export enum SmartJeffProjectStatus {
    Draft = 'Draft',
    Active = 'Active',
    Waiting = 'Waiting',
    Resolved = 'Resolved',
    Canceled = 'Canceled',
}

